<template>
  <svg>
    <!-- Than Ty THin Ngo-->
    <template v-if="cungMenh === 1">
      <line x1="90" y1="0" x2="270" y2="513" stroke="#9d9393" :stroke-dasharray="isShowTuHoaTv ? 4 : 0"/> <!-- ngo ty -->
      <line x1="0" y1="120" x2="270" y2="513" stroke="#9d9393" :stroke-dasharray="isShowTuHoaTv ? 4 : 0"/> <!-- ty thin -->
      <line x1="360" y1="0" x2="270" y2="513" stroke="#9d9393" :stroke-dasharray="isShowTuHoaTv ? 4 : 0"/> <!-- ty than -->
    </template>
    <!-- Ti Dau Suu Mui-->
    <template v-if="cungMenh === 2">
      <line x1="0" y1="0" x2="90" y2="513" stroke="#9d9393" :stroke-dasharray="isShowTuHoaTv ? 4 : 0"/> <!-- Ti Suu -->
      <line x1="90" y1="513" x2="270" y2="0" stroke="#9d9393" :stroke-dasharray="isShowTuHoaTv ? 4 : 0"/> <!-- Suu Mui-->
      <line x1="90" y1="513" x2="360" y2="120" stroke="#9d9393" :stroke-dasharray="isShowTuHoaTv ? 4 : 0"/> <!-- Suu Dau-->
    </template>
    <!-- Dan ngo tuat than-->
    <template v-if="cungMenh === 3">
      <line x1="90" y1="0" x2="0" y2="513" stroke="#9d9393" :stroke-dasharray="isShowTuHoaTv ? 4 : 0"/> <!-- Dan ngo -->
      <line x1="0" y1="513" x2="513" y2="310" stroke="#9d9393" :stroke-dasharray="isShowTuHoaTv ? 4 : 0"/> <!-- Dan tuat -->
      <line x1="0" y1="513" x2="360" y2="0" stroke="#9d9393" :stroke-dasharray="isShowTuHoaTv ? 4 : 0"/> <!-- Dan than -->
    </template>
    <!-- Hoi Mao Mui Dau-->
    <template v-if="cungMenh === 4">
      <line x1="0" y1="370" x2="360" y2="513" stroke="#9d9393" :stroke-dasharray="isShowTuHoaTv ? 4 : 0"/> <!-- Mao Hoi -->
      <line x1="0" y1="370" x2="270" y2="0" stroke="#9d9393" :stroke-dasharray="isShowTuHoaTv ? 4 : 0"/> <!-- Mao Mui -->
      <line x1="0" y1="370" x2="360" y2="120" stroke="#9d9393" :stroke-dasharray="isShowTuHoaTv ? 4 : 0"/> <!-- Mao Dau -->
    </template>
    <!-- Than Ty THin tuat-->
    <template v-if="cungMenh === 5">
      <line x1="0" y1="120" x2="360" y2="370" stroke="#9d9393" :stroke-dasharray="isShowTuHoaTv ? 4 : 0"/> <!-- thin tuat -->
      <line x1="0" y1="120" x2="270" y2="513" stroke="#9d9393" :stroke-dasharray="isShowTuHoaTv ? 4 : 0"/> <!-- ty thin -->
      <line x1="360" y1="0" x2="0" y2="120" stroke="#9d9393" :stroke-dasharray="isShowTuHoaTv ? 4 : 0"/> <!-- thin than -->
    </template>
    <!-- Ti Dau Suu Mao-->
    <template v-if="cungMenh === 6">
      <line x1="0" y1="0" x2="90" y2="513" stroke="#9d9393" :stroke-dasharray="isShowTuHoaTv ? 4 : 0"/> <!-- Ti Suu -->
      <line x1="0" y1="0" x2="360" y2="120" stroke="#9d9393" :stroke-dasharray="isShowTuHoaTv ? 4 : 0"/> <!-- Ti Dau -->
      <line x1="0" y1="0" x2="360" y2="513" stroke="#9d9393" :stroke-dasharray="isShowTuHoaTv ? 4 : 0"/> <!-- Hoi Ti -->
    </template>
    <!-- Dan ngo tuat ti-->
    <template v-if="cungMenh === 7">
      <line x1="90" y1="0" x2="0" y2="513" stroke="#9d9393" :stroke-dasharray="isShowTuHoaTv ? 4 : 0"/> <!-- Dan ngo -->
      <line x1="90" y1="0" x2="360" y2="370" stroke="#9d9393" :stroke-dasharray="isShowTuHoaTv ? 4 : 0"/> <!-- ngo tuat -->
      <line x1="90" y1="0" x2="270" y2="513" stroke="#9d9393" :stroke-dasharray="isShowTuHoaTv ? 4 : 0"/> <!-- ngo ti -->
    </template>
    <!-- Hoi Mao Mui Suu-->
    <template v-if="cungMenh === 8">
      <line x1="360" y1="513" x2="270" y2="0" stroke="#9d9393" :stroke-dasharray="isShowTuHoaTv ? 4 : 0"/> <!-- Mui Hoi -->
      <line x1="0" y1="370" x2="270" y2="0" stroke="#9d9393" :stroke-dasharray="isShowTuHoaTv ? 4 : 0"/> <!-- Mui Mao -->
      <line x1="90" y1="513" x2="270" y2="0" stroke="#9d9393" :stroke-dasharray="isShowTuHoaTv ? 4 : 0"/> <!-- Mui Suu -->
    </template>
    <!-- Than Ty THin dan-->
    <template v-if="cungMenh === 9">
      <line x1="360" y1="0" x2="0" y2="513" stroke="#9d9393" :stroke-dasharray="isShowTuHoaTv ? 4 : 0"/> <!-- dan than -->
      <line x1="360" y1="0" x2="270" y2="513" stroke="#9d9393" :stroke-dasharray="isShowTuHoaTv ? 4 : 0"/> <!-- ty than -->
      <line x1="360" y1="0" x2="0" y2="120" stroke="#9d9393" :stroke-dasharray="isShowTuHoaTv ? 4 : 0"/> <!-- thin than -->
    </template>
    <!-- Ti Dau Suu Mao-->
    <template v-if="cungMenh === 10">
      <line x1="0" y1="0" x2="360" y2="120" stroke="#9d9393" :stroke-dasharray="isShowTuHoaTv ? 4 : 0"/> <!-- Ti Dau -->
      <line x1="0" y1="370" x2="360" y2="120" stroke="#9d9393" :stroke-dasharray="isShowTuHoaTv ? 4 : 0"/> <!-- Mao Dau -->
      <line x1="90" y1="513" x2="360" y2="120" stroke="#9d9393" :stroke-dasharray="isShowTuHoaTv ? 4 : 0"/> <!-- Suu Dau-->
    </template>
    <!-- Dan ngo tuat thin-->
    <template v-if="cungMenh === 11">
      <line x1="360" y1="370" x2="0" y2="513" stroke="#9d9393" :stroke-dasharray="isShowTuHoaTv ? 4 : 0"/> <!-- Dan tuat -->
      <line x1="90" y1="0" x2="360" y2="370" stroke="#9d9393" :stroke-dasharray="isShowTuHoaTv ? 4 : 0"/> <!-- ngo tuat -->
      <line x1="0" y1="120" x2="360" y2="370" stroke="#9d9393" :stroke-dasharray="isShowTuHoaTv ? 4 : 0"/> <!-- thin tuat -->
    </template>
    <!-- Hoi Mao Mui Ti-->
    <template v-if="cungMenh === 12">
      <line x1="0" y1="0" x2="360" y2="513" stroke="#9d9393" :stroke-dasharray="isShowTuHoaTv ? 4 : 0"/> <!-- Hoi Ti -->
      <line x1="0" y1="370" x2="360" y2="513" stroke="#9d9393" :stroke-dasharray="isShowTuHoaTv ? 4 : 0"/> <!-- Hoi mao -->
      <line x1="270" y1="0" x2="360" y2="513" stroke="#9d9393" :stroke-dasharray="isShowTuHoaTv ? 4 : 0"/> <!-- Hoi mui -->
    </template>
  </svg>
</template>

<script>
export default {
  name: 'LineMenh',
  props: {
    cungMenh: {
      type: Number,
      default: null
    },
    isShowTuHoaTv: {
      type: Boolean,
      default: null
    }
  }
}
</script>

<style scoped>

</style>
